import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NipFieldsService {
  /**
   * @description
   * Services that end with an extension '-fields.service.ts'
   * are only used to write the configuration for the form builder component.
   * Here you can define all the fields as well as the layout of the form.
   */

  /**
   * * Table header
   */
  tableHeader = [
    {
      field: 'batch',
      header: 'Šarža br',
    },
    {
      field: 'created_at',
      header: 'Datum otvaranja',
    },
    {
      field: 'clientName',
      header: 'Klijent',
    },
    {
      field: 'request_nr',
      header: 'Zahtev br',
    },
    {
      field: 'deadline',
      header: 'Rok za izradu',
    },
    {
      field: 'productName',
      header: 'Naziv proizvoda',
    },
    {
      field: 'currentStatus',
      header: 'Trenutno stanje',
    },
    {
      field: 'exportPdf',
      header: 'KL',
      custom: true,
      options: {
        width: 'width:4rem',
      },
    },
    {
      field: 'exportNip',
      header: 'NIP export',
      custom: true,
      options: {
        width: 'width:6rem',
      },
    },
  ];

  documentTableFields = [
    {
      field: 'name',
      header: 'Naziv dokumenta',
    },
  ];

  constructor() {}
}
